import styled from 'styled-components'
import { VscClose } from 'react-icons/vsc'
import { AiOutlineSearch } from 'react-icons/ai'
import { useEffect, useState } from 'react'

const TextSearch = ({
  data,
  onChange,
}: {
  data: Person[]
  onChange: (filteredData: Person[]) => void
}) => {
  const [textValue, setTextValue] = useState<string>('')
  const [textSearch, setTextSearch] = useState<string | null>(null)

  useEffect(() => {
    const outputItems = textSearch
      ? data.filter((item: Person) => {
          return [
            item.mainSector,
            item.businessName,
            item.name,
            item.sectors,
            item.residence,
          ]
            .join(' ')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .includes(
              textSearch
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
            )
        })
      : data

    onChange(outputItems)
  }, [textSearch, data])

  return (
    <Container>
      <Input
        value={textValue}
        onKeyDown={(e) => {
          e.key === 'Enter' && (e.target as HTMLTextAreaElement).blur()
        }}
        placeholder='Que recherchez-vous?'
        type='text'
        onChange={(e) => {
          const val = e.target.value
          setTextValue(val)
          if (val.length > 2) {
            setTextSearch(val)
          } else {
            setTextSearch(null)
          }
        }}
      />
      {textValue.length > 0 && (
        <ResetIcon
          onClick={() => {
            setTextValue('')
            setTextSearch(null)
          }}
        >
          <VscClose />
        </ResetIcon>
      )}
      <SearchIcon>
        <AiOutlineSearch />
      </SearchIcon>
    </Container>
  )
}

const Container = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 700;
  font-size: 1.5rem;
  display: inline-flex;
  align-items: center;
  border-bottom: 2px solid ${({ theme }) => theme.colorMain};
  background-color: ${({ theme }) => `${theme.grayColor}99`};
  flex: 1;
`

const Input = styled.input`
  border-radius: 0;
  padding: 15px;
  border: 0;
  width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.siteBackground};
  outline: none;
  -webkit-appearance: none;
  font-size: 1.6rem;
  font-family: var(--font-sans-serif);
  color: ${({ theme }) => theme.textColor};
  margin: 0;
`

const ResetIcon = styled.div`
  font-size: 2.25rem;
  color: ${({ theme }) => theme.textColor};
  display: flex;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
`

const SearchIcon = styled.div`
  font-size: 2.25rem;
  color: ${({ theme }) => theme.textColor};
  display: flex;
  align-items: center;
  padding: 0 15px;
`

export default TextSearch
